<script>
import Customers from '@/services/Customers';
import TreeNode from "@/components/tabs/TreeNode.vue";

export default {
  props: ['eventData'],
  components: { TreeNode },
  data() {
    return {
      showModal: false,
      emailDetails: [],
      searchQuery: '',
      emailDetailsLoader: false
    };
  },

  methods: {

    closeModal() {
      this.showModal = false
    },

    async getEmailEventDetails() {
      try {
        this.emailDetailsLoader = true;
        const response = await Customers.getEmailEventDetails(this.eventData.event_id)
        const emailDetails = response.data.data

        if (Array.isArray(emailDetails) && emailDetails[0] && emailDetails[0].data) {
          const outer = JSON.parse(emailDetails[0].data)
          const ses = outer.body.Message
          this.emailDetails = this.deepParseJsonStrings(ses);
        } else {
          this.emailDetails = []
        }

        this.toggleBusy();
      } catch (error) {
        this.toggleBusy();
        this.error = error.response.data.error ? error.response.data.error : "";
      } finally {
        this.emailDetailsLoader = false;
      }
    },

    deepParseJsonStrings(value, depth = 0) {
      if (depth > 4) return value;
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          return this.deepParseJsonStrings(parsed, depth + 1);
        } catch {
          return value;
        }
      }
      if (Array.isArray(value)) {
        return value.map(v => this.deepParseJsonStrings(v, depth + 1));
      }
      if (value && typeof value === 'object') {
        const out = {};
        Object.keys(value).forEach(k => {
          out[k] = this.deepParseJsonStrings(value[k], depth + 1);
        });
        return out;
      }
      return value;
    },

    showData(){
      this.getEmailEventDetails()
    },

    resetProps(){
      this.emailDetails = []
    }
  }
}
</script>

<template>
  <b-modal @shown="showData" @hidden="resetProps" v-model="showModal" id="view_event_details" title="View Email Event Details" title-class="font-18" size="xl" centered>
    <div class="card">
      <div class="card-body">
          <template>
            <h4>Summary</h4>
            <div class="row">
              <div class="col-4">
                <div class="col-sm-12 col-md-12"><strong>Event Type:</strong> {{eventData.eventType}}</div>
                <div class="col-sm-12 col-md-12"><strong>Email Type:</strong> {{eventData.email_type}}</div>
              </div>
              <div class="col-4">
                <div class="col-sm-12 col-md-12"><strong>Recipient ISP:</strong> {{eventData.recipient_isp}}</div>
                <div class="col-sm-12 col-md-12"><strong>Tenant:</strong> {{eventData.tenant}}</div>
              </div>
              <div class="col-4">
                <div class="col-sm-12 col-md-12"><strong>Event Daytime:</strong> {{eventData.event_datetime}}</div>
                <div class="col-sm-12 col-md-12"><strong>Email Timestamp:</strong> {{eventData.timestamp}}</div>
              </div>
            </div>

            <hr/>
            <div v-if="!emailDetailsLoader">
              <div class="row" v-if="emailDetails">
                <h4>Event Details</h4>
                <TreeNode :node-val="emailDetails || {}" :path="'$'" :search="searchQuery" />
              </div>
            </div>
            <div v-else>
              <div class="card-body d-flex align-items-center justify-content-center" v-if="emailDetailsLoader">
                <b-spinner large></b-spinner>
              </div>
            </div>

          </template>
      </div>
    </div>
  </b-modal>
</template>



